/* Live alerts: what needs the signed-in person now (a session has started: Join), over whatever page they are on. The apps say what (website_hq/live_alerts.py); this file holds no wording.
   It asks every few seconds while the page is in view, at once when the server says something happened (a live "rfhq_live_alert" message), and when the page comes back into view. */
(function () {
	"use strict";
	const EVERY_MS = 8000;
	const signedIn = () => /(?:^|;\s*)user_id=(?!Guest)/.test(document.cookie);
	const asked = async () => {
		try {
			const response = await fetch("/api/method/raftor_websitehq.website_hq.live_alerts.get", { method: "POST", credentials: "same-origin",
				headers: { "Content-Type": "application/json", Accept: "application/json", "X-Frappe-CSRF-Token": window.csrf_token || (window.frappe && frappe.csrf_token) || "" }, body: "{}" });
			return response.ok ? (await response.json()).message || [] : [];
		} catch (e) { return []; }
	};
	const SHOW_MS = 8000; // a notice shows for a few seconds and fades back; it does not stay (the app's own inbox keeps the record)
	let box = null;
	const seen = (() => { try { return new Set(JSON.parse(sessionStorage.getItem("rfhq-alerts-seen") || "[]")); } catch (e) { return new Set(); } })();
	const remember = () => { try { sessionStorage.setItem("rfhq-alerts-seen", JSON.stringify([...seen].slice(-100))); } catch (e) { /* no storage: it may show again on the next page */ } };
	function draw(alerts) {
		const fresh = alerts.filter((a) => !seen.has(a.id)); // each is shown once: it fades back and is not put up again on the next look or the next page
		if (!fresh.length) return;
		if (!box) { box = document.createElement("div"); box.className = "rfhq-live-alerts"; box.setAttribute("role", "alert"); document.body.appendChild(box); }
		fresh.forEach((a) => {
			seen.add(a.id);
			const row = document.createElement("div"); row.className = "rfhq-live-alert";
			const text = document.createElement("div"); text.className = "rfhq-live-alert-text";
			const title = document.createElement("strong"); title.textContent = a.title;
			const line = document.createElement("span"); line.textContent = a.line;
			text.append(title, line);
			const go = document.createElement("a"); go.className = "btn btn-primary rfhq-live-alert-go"; go.href = a.href; go.textContent = a.label;
			row.append(text, go); box.appendChild(row);
			const gone = () => { row.classList.add("is-fading"); setTimeout(() => row.remove(), 450); };
			setTimeout(gone, SHOW_MS);
			row.addEventListener("click", (event) => { if (!event.target.closest("a")) gone(); }); // a tap on the notice itself puts it away
		});
		remember();
		try { navigator.vibrate && navigator.vibrate([200, 100, 200]); } catch (e) { /* no vibration */ }
	}
	async function refresh() { if (!document.hidden) draw((await asked()).filter((a) => a.href !== location.pathname + location.search)); } // (not one for the page they are on)
	function init() {
		if (!signedIn()) return;
		refresh();
		setInterval(refresh, EVERY_MS);
		document.addEventListener("visibilitychange", refresh);
		try { if (window.frappe && frappe.realtime && frappe.realtime.on) frappe.realtime.on("rfhq_live_alert", refresh); } catch (e) { /* the polling is enough */ }
	}
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
})();
